import React from 'react';

import { Stack } from '@metarouter-private/mr-mui';
import { useAuditLogPage, PAGE_SIZE, QUERY_STATUS, offsetPaging } from '@ion/api/audit-logs/query';

import AuditLogTable from './AuditLogTable';
import AuditLogEmptyState from './AuditLogEmptyState';
import AuditLogErrorState from './AuditLogErrorState';
import AuditLogStatus from './AuditLogStatus';
import auditLogPropTypes from 'app/audit-logs/auditLogPropTypes';
import usePaginationResetToggle from './usePaginationResetToggle';

const GLOBAL_EMPTY_MESSAGE = 'There are no records to display';

export default function AuditLogPanelForGlobal({ globalFilters }) {
  const { rows, pageInfo, totalCount, hasActiveFilters, loading, status, sortDirection, onSortDirectionChange } =
    useAuditLogPage({
      globalFilters,
      pagingStrategy: offsetPaging,
      pageSize: PAGE_SIZE,
    });

  const { paginationResetDefaultPage } = usePaginationResetToggle({ globalFilters, sortDirection });
  const handleFetchPage = ({ page }) => pageInfo.goToPosition(page);

  return (
    <Stack spacing={2}>
      <AuditLogStatus count={totalCount} status={status} />
      {renderGlobalBody({
        status,
        rows,
        loading,
        totalCount,
        hasActiveFilters,
        handleFetchPage,
        sortDirection,
        onSortDirectionChange,
        paginationResetDefaultPage,
      })}
    </Stack>
  );
}

function renderGlobalBody({
  status,
  rows,
  loading,
  totalCount,
  hasActiveFilters,
  handleFetchPage,
  sortDirection,
  onSortDirectionChange,
  paginationResetDefaultPage,
}) {
  if (status === QUERY_STATUS.ERROR) return <AuditLogErrorState />;
  if (status === QUERY_STATUS.EMPTY) return <AuditLogEmptyState message={GLOBAL_EMPTY_MESSAGE} />;

  return (
    <AuditLogTable
      rows={rows}
      loading={loading}
      hasActiveFilters={hasActiveFilters}
      pagination={{ count: totalCount }}
      showPagination
      onFetchPage={handleFetchPage}
      sortDirection={sortDirection}
      onSort={onSortDirectionChange}
      paginationResetDefaultPage={paginationResetDefaultPage}
    />
  );
}

AuditLogPanelForGlobal.propTypes = {
  globalFilters: auditLogPropTypes.globalFilters.isRequired,
};
